export default (context = {}) =>
  fieldLibrary = {
    fieldGroups: {
      bulk: {
        _requiredFields: ['name']
        space:
          name: 'Asset Settings'
          description: 'Lorem ipsum dolor sit amet'
          fieldKeys: ['description', 'services', 'images']
      }
    }
    fields: {
      segment: {
        name: 'Name'
        component: 'text'
        inputProps: {
          placeholder: 'Name'
          replace: { ':': ' -' }
        }
        options: {
          instructions: 'Name the asset specifying where this will be placed'
          why: ''
          tips: [
            "This asset can be shared accross different experiences"
            "You can add 10x10 booths multiple times with different prices by creating multiple placements"
            ]
          examples: [
            'Front Gate'
            'Break Room'
            'Lobby'
            'Door Hanger'
          ]

        }
      }
      description: {
        name: 'Asset Description'
        component: 'textarea'
        inputProps: {
          placeholder: 'Description of area'
        }
        options: {
          instructions: 'Give sponsors a better idea of what this distribution area is like'
          examples: [
            'Products will be placed on kitchen counter for people to discover'
            'Visitors coming into the lobby will be able to engage with your'
            'Ticket holders coming into the front gate will engage with your activation'
            'We can put products in a bag and hang them on doorknobs'
          ]
        }
      }
      services: {
        name: 'Services'
        component: 'switch'
        inputProps: {
          items: [
            {
              key: 'can_serve_cold'
              label: 'Staff can serve food/beverage cold'
              description: 'My team can chill samples prior to handing them out'
            }
            {
              key: 'can_assemble_items'
              label: 'Staff can assemble items before handing them out'
              description: 'My team can package items into bags / boxes prior to handing them out'
            }
          ]
        }
        options: {
          instructions: 'Let sponsors know which services your team is able to provide and upcharge for'
          why: 'Some sponsors need your help to make their activation a success'
        }
      }
      images: {
        name: 'Photos'
        component: 'media'
        options: {
          instructions: 'Upload pictures showing the area where samples will be handed out for this asset'
          why: '16:9 aspect size ratio with high resolution shows up best'
          tips: ["acceptable formats are:", "jpg", "png", "gif"]
        }
      },
      spaces: {
        name: 'Set Your Daily Pricing'
        component: 'onsite-space-pricing'
        options: {
          instructions: 'List the purchase price you want to offer these onsite spaces for:'
        }
      }
      omnichannel: {
        name: 'Online Platforms'
        component: 'omnichannel'
        options: {
          required: true
          instructions: 'Let brands know which platforms are available for them to post a message'
          why: 'Setting up social & digital will expose you to more opportunities from brands who want to support their activation online'
          alwaysShowWhy: true
        }
      }
      omnichannel_national: {
        name: 'Hosted at these Venues'
        component: 'radio-button'
        inputProps: {
          options: [
            { value: false, label: 'Venue' }
            { value: true, label: 'National' }
          ]
        }
        options: {
          instructions: 'Select which venues your account handle represents'
        }
      }
    }
  }

  library = JSON.parse(JSON.stringify(fieldLibrary))

  for key, field of library.fields
    field.inputProps ||= context.inputProps?[key] || {}
    field.inputProps?.options ||= context.options?[key]
    field.options.required = key in (context._requiredFields || [])

  library
